import $ from 'jquery';
import slick from 'slick-carousel';

class MainCopy {
  constructor(target) {
    this.lang = target.find('.btn__languageList');
    this.contents = target.find('.mainCopy__p');
    this.contents.slick({
      fade: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true,
      centerMode: false,
      arrows: false,
      dots: false,
      swipe:false
    });

    this.lang.slick({
      slidesToShow: 3,
      // slidesToScroll: 3,
      asNavFor: '.mainCopy__p',
      dots: false,
      centerMode: false,
      adaptiveHeight: true,
      focusOnSelect: true,
      swipe:false
    });
  }
}

(() => {
  const targets = $('.mainCopy');
  if (!targets.length) return;
  new MainCopy(targets);
})();
